import { render } from "./Footer.vue?vue&type=template&id=c24622e2"
const script = {}
script.render = render

export default script